module.exports = __webpack_public_path__ + "img/p_4.2bf3be70.jpg";